import { type Theme, useMediaQuery } from '@mui/material'

/** On narrow screens (below `md`), the app switches to its mobile layout: the mobile navigation, full-width panels */
export const useIsMobile = (): boolean => useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
